import gql from 'graphql-tag'

export const CREATE_PAIN_RATING_MUTATION = gql`
mutation CreatePainRatingMutation(
  $token: String!,
  $painRating: Int!,
) {
  createPainRating(
    token: $token,
    painRating: $painRating,
  ) {
    id
  }
}
`



// WEBPACK FOOTER //
// ./src/mutations/CREATE_PAIN_RATING_MUTATION.ts